import React, { useEffect } from "react";
import ComponentContainer from "../components/ComponentContainer";
import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import MainCard from "../components/Cards/MainCard";
import MainCarousel from "../components/Carousels/MainCarousel";
import "../css/main.css";
import mainCarouselImage1 from "../assets/img/possibilities/back/image 1.png";
import mainCarouselImage2 from "../assets/img/possibilities/back/image.png";
import mainCarouselImage3 from "../assets/img/possibilities/back/image (1).png";
import mainCarouselImage4 from "../assets/img/possibilities/back/image (2).png";
import mainCarouselImage5 from "../assets/img/possibilities/back/image (3).png";
import mainCarouselImage6 from "../assets/img/possibilities/back/image (4).png";
import mainCarouselImage7 from "../assets/img/possibilities/back/image (5).png";
import mainCarouselImage8 from "../assets/img/possibilities/back/image (6).png";
import mainCarouselImage9 from "../assets/img/possibilities/back/image (7).png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ReactComponent as MainCarouselSvg1 } from "../assets/svg/possibility/main/Vector.svg";
import { ReactComponent as MainCarouselSvg2 } from "../assets/svg/possibility/main/Vector (1).svg";
import { ReactComponent as MainCarouselSvg3 } from "../assets/svg/possibility/main/Vector (2).svg";
import { ReactComponent as MainCarouselSvg4 } from "../assets/svg/possibility/main/Vector (3).svg";
import { ReactComponent as MainCarouselSvg5 } from "../assets/svg/possibility/main/feShield.svg";
import { ReactComponent as MainCarouselSvg6 } from "../assets/svg/possibility/main/Vector (4).svg";
import { ReactComponent as MainCarouselSvg7 } from "../assets/svg/possibility/main/Vector (5).svg";
import { ReactComponent as MainCarouselSvg8 } from "../assets/svg/possibility/main/Vector (6).svg";
import { ReactComponent as MainCarouselSvg9 } from "../assets/svg/possibility/main/Vector (7).svg";
import Button from "../components/Button";
import cardImageHarbor1 from "../assets/img/main-card/harbor/Mid.png";
import cardImageHarbor1Extended from "../assets/img/main-card/harbor/Extended_Mid.png";
import cardImageHarbor2 from "../assets/img/main-card/harbor/Floor.png";
import cardImageHarbor3 from "../assets/img/main-card/harbor/Dinos.png";
import cardImageDomination1 from "../assets/img/main-card/domination/Mid.png";
import cardImageDomination1Extended from "../assets/img/main-card/domination/Extended_Mid.png";
import cardImageDomination2 from "../assets/img/main-card/domination/Floor.png";
import cardImageDomination3 from "../assets/img/main-card/domination/Dinos.png";
import cardImageLegacy1 from "../assets/img/main-card/legacy/Mid.png";
import cardImageLegacy1Extended from "../assets/img/main-card/legacy/Extended_Mid.png";
import cardImageLegacy2 from "../assets/img/main-card/legacy/Floor.png";
import cardImageLegacy3 from "../assets/img/main-card/legacy/Dinos.png";
import { ReactComponent as DiscordSvg } from "../assets/svg/discord.svg";
import { ReactComponent as TgSvg } from "../assets/svg/tg.svg";
import { ReactComponent as YoutubeSvg } from "../assets/svg/youtube.svg";
import A from "../components/A";
import MainTransitionLayer from "../components/MainTransitionLayer";
import sharkClippedImg from "../assets/img/background/Shark-clipped.png";

const Main = () => {
  // добавить класс для стилей
  useEffect(() => {
    const pageContainer = document.querySelector("#root");
    pageContainer.classList.add("main");

    return () => {
      pageContainer.classList.remove("main");
    };
  }, []);

  const mainCarouselImages = [
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage1} />
      <MainCarouselSvg1 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage2} />
      <MainCarouselSvg2 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage3} />
      <MainCarouselSvg3 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage4} />
      <MainCarouselSvg4 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage5} />
      <MainCarouselSvg5 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage6} />
      <MainCarouselSvg6 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage7} />
      <MainCarouselSvg7 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage8} />
      <MainCarouselSvg8 />
    </div>,
    <div>
      <LazyLoadImage alt="" src={mainCarouselImage9} />
      <MainCarouselSvg9 />
    </div>,
  ];

  const mainCarouselTitles = [
    "Многопользовательская игра",
    "Захватывающие задания и квесты",
    "Разнообразие динозавров",
    "Развитие и улучшение",
    "Создание гильдий",
    "Онлайн соревнования",
    "Система слотов",
    "Постоянные обновления и нововведения",
    "Поддержка и помощь",
  ];

  const mainCarouselDescriptions = [
    "Сервер предоставляет возможность играть с другими игроками со всего мира. Вы можете кооперироваться с другими игроками, составлять команды и вместе исследовать удивительный мир динозавров.",
    "Сервер предлагает интересные и захватывающие задания и квесты для всех игроков.",
    "Сервер предлагает широкий выбор различных видов динозавров для игроков. Каждый динозавр имеет свои уникальные характеристики и способности, что позволяет игрокам выбирать тот, который больше всего подходит их стилю игры.",
    "Сервер предоставляет возможность развивать своего динозавра, повышая его уровень и улучшая его навыки. Вы сможете приобретать новые атаки, защиту и специальные способности, чтобы стать еще более мощным и эффективным в битвах.",
    "Гильдия - это возможность создать свое небольшое сообщество из друзей, единомышленников и просто хороших людей. Вы можете создать свою атмосферу, где всем будет комфортно.",
    "Сервер регулярно организует различные соревнования и турниры для игроков. Вы сможете соревноваться с другими игроками, доказывая свое мастерство и получая призы и награды.",
    "СЛОТЫ – место,  где будет храниться динозавр, слоты можно деактивировать и активировать. Таким образом, игрок может хранить на одном аккаунте несколько динозавров.",
    "Администрация сервера и сайта постоянно работает над обновлениями и добавлением новых функций и возможностей. Это позволяет игрокам всегда находить что-то новое и интересное в игре.",
    "Сервер и сайт предоставляют поддержку и помощь игрокам. Вы можете обратиться к администрации сервера с любыми вопросами, проблемами или предложениями и получить профессиональную поддержку.",
  ];

  const cardHarborProps = {
    title: "HARBOR",
    serverName: "EVRIMA",
    players: 197,
    maxPlayers: 230,
    backImage: cardImageHarbor1Extended,
    groundImage: cardImageHarbor2,
    dinosImage: cardImageHarbor3,
  };

  const cardDominationProps = {
    title: "DOMINATION",
    serverName: "EVRIMA",
    players: 125,
    maxPlayers: 230,
    backImage: cardImageDomination1Extended,
    groundImage: cardImageDomination2,
    dinosImage: cardImageDomination3,
  };

  const cardLegacyProps = {
    title: "LEGACY",
    serverName: "EVRIMA",
    players: 5,
    maxPlayers: 230,
    backImage: cardImageLegacy1Extended,
    groundImage: cardImageLegacy2,
    dinosImage: cardImageLegacy3,
  };

  return (
    <>
      <MainTransitionLayer />
      <MainHeader />
      <div className="main-page page">
        <ComponentContainer>
          <div className="server-cards">
            <div className="main-cards-container">
              <MainCard {...cardHarborProps} className={"harbor"} />
              <MainCard {...cardDominationProps} className={"domination"} />
              <MainCard {...cardLegacyProps} className={"legacy"} />
            </div>
            <div className="center">
              <Button className="start-diving no-background accent spiked">
                НАЧАТЬ ИГРАТЬ
              </Button>
            </div>
            <LazyLoadImage
              src={sharkClippedImg}
              alt=""
              className="shark-clipped"
            />
          </div>
        </ComponentContainer>
        <ComponentContainer>
          <div className="main-page-carousel">
            <MainCarousel
              images={mainCarouselImages}
              titles={mainCarouselTitles}
              descriptions={mainCarouselDescriptions}
            />
            <div className="main-page-about">
              <div className="main-page-about-title">О НАС</div>
              <div className="main-page-about-text">
                <span className="text-accent">MEGALODON</span> — Это
                инновационный игровой проект, который предоставляет игрокам
                возможность общаться и совместно играть на наших серверах.
                <br />
                Мы строго придерживаемся установленных правил и применяем
                современные подходы для создания дружелюбной и позитивной
                атмосферы, где каждый игрок может чувствовать себя комфортно.
                <br />
                Проект был основан 1 февраля 2023 года.
              </div>
              <div className="buttons">
                <div className="center">
                  <Button className="start-diving no-background accent spiked">
                    НАЧАТЬ ПОГРУЖЕНИЕ
                  </Button>
                </div>
                <div className="center megalodon-links">
                  <A href="https://discord.gg/megalodon">
                    <DiscordSvg />
                  </A>
                  <A href="https://t.me/Theislemegalodon">
                    <TgSvg />
                  </A>
                  <A href="#">
                    <YoutubeSvg />
                  </A>
                </div>
              </div>
            </div>
          </div>
        </ComponentContainer>
      </div>
      <MainFooter />
    </>
  );
};

export default Main;
